import * as React from 'react'
import { RouteProps } from 'react-router'
import { Button } from '../Button'
import { CookieBannerWrapper, StyledText, StyledLink } from './CookieBanner.style'
import { Block } from '../Layout/Block'
import { theme } from '$utils/theme'
import { Link } from '$views/components/Link'
import { Text } from '$views/components/Text'
import { CookieSettingsModal } from '$views/components/CookieBanner/components/CookieSettingsModal'
import { isCookiesLawAcepted } from '$services/user/cookiesLaw/isCookiesAcepted.service'
import { isCookiesPreferencesAcepted } from '$services/user/cookiesPreferences/isCookiesAcepted.service'
import { isCookiesStatisticsAcepted } from '$services/user/cookiesStatistics/isCookiesAcepted.service'
import { EventSystem } from '$utils/services/eventSystem/eventSystem'
import { EventSystemName } from '$utils/services/eventSystem/eventSystemName'
import { handleCookiesLaw } from '$services/user/cookiesLaw/handleCookiesLaw.service'
import { handleCookiesPreferences } from '$services/user/cookiesPreferences/handleCookiesPreferences.service'
import { handleCookiesStatistics } from '$services/user/cookiesStatistics/handleCookiesStatistics.service'
import history from '$utils/history'
import { routeProvider } from '$utils/routeProvider'
import { MediaQueryOwn } from '$views/components/MediaQueryOwn'

interface WindowWithNativeProps extends Window {
  isNativeApp?: any
  ReactNativeWebView?: any
}

export const CookieBanner: React.FC<RouteProps> = ({ children }) => {
  const [hasAceptedCookies, setAceptedCookies] = React.useState<boolean>(false)
  const [settingsCookies, setSettingsCookies] = React.useState<boolean>(false)
  const [preferenceCookies, setPreferencesCookies] = React.useState<boolean>(true)
  const [statisticsCookies, setStatisticsCookies] = React.useState<boolean>(true)
  const windowsWithNativeProps: WindowWithNativeProps = window

  React.useEffect(() => {
    EventSystem.addAppEventListener(EventSystemName.cookieSettings, () => setSettingsCookies(true))
    setAceptedCookies(isCookiesLawAcepted() === 'true')
    setPreferencesCookies(isCookiesPreferencesAcepted() === 'true')
    setStatisticsCookies(isCookiesStatisticsAcepted() === 'true')
  }, [])

  const onClickAceptCookiesLaw = () => {
    handleCookiesLaw(true)
    handleCookiesPreferences(true)
    handleCookiesStatistics(true)
    setAceptedCookies(!hasAceptedCookies)
    setPreferencesCookies(true)
    setStatisticsCookies(true)
  }

  const onClickCookiesMoreInfo = () => {
    history.push(routeProvider.cookies)
  }

  const onClickSaveCookies = () => {
    handleCookiesPreferences(preferenceCookies)
    handleCookiesStatistics(statisticsCookies)
    setSettingsCookies(false)
  }

  if (hasAceptedCookies) {
    return (
      <>
        {children}
        {settingsCookies && (
          <CookieSettingsModal
            onSubmit={() => onClickSaveCookies()}
            statisticsCookies={statisticsCookies}
            preferenceCookies={preferenceCookies}
            setPreferencesCookies={() => setPreferencesCookies(!preferenceCookies)}
            setStatisticsCookies={() => setStatisticsCookies(!statisticsCookies)}
            handleSettingsCookies={() => setSettingsCookies(!settingsCookies)}
          />
        )}
      </>
    )
  }

  return (
    <>
      {children}
      {settingsCookies && (
        <CookieSettingsModal
          onSubmit={() => onClickSaveCookies()}
          statisticsCookies={statisticsCookies}
          preferenceCookies={preferenceCookies}
          setPreferencesCookies={() => setPreferencesCookies(!preferenceCookies)}
          setStatisticsCookies={() => setStatisticsCookies(!statisticsCookies)}
          handleSettingsCookies={() => setSettingsCookies(!settingsCookies)}
        />
      )}

      {!windowsWithNativeProps.ReactNativeWebView && (
        <CookieBannerWrapper>
          <StyledText menu marginRight="base">
            Utilizamos cookies propias y de terceros que recogen y analizan información con la finalidad de personalizar
            tu experiencia.{' '}
            <StyledLink href="#" onClick={onClickCookiesMoreInfo}>
              Más información
            </StyledLink>
          </StyledText>
          <Block marginTop="mini">
            <MediaQueryOwn minWidth={theme.breakpoints.desktop}>
              <Block flex alignItems="center">
                <Button secondary mini onClick={onClickAceptCookiesLaw}>
                  Aceptar
                </Button>
                <Block marginLeft="mini">
                  <Text menu>
                    <Link href="#" onClick={() => setSettingsCookies(true)}>
                      Gestionar o rechazar cookies
                    </Link>
                  </Text>
                </Block>
              </Block>
            </MediaQueryOwn>
            <MediaQueryOwn maxWidth={theme.breakpoints.desktop - 1}>
              <Block flex alignItems="center">
                <Button primary bordered mini onClick={onClickAceptCookiesLaw}>
                  Aceptar
                </Button>
                <Block marginLeft="mini">
                  <Text menu>
                    <Link href="#" onClick={() => setSettingsCookies(true)} color="white">
                      Gestionar o rechazar cookies
                    </Link>
                  </Text>
                </Block>
              </Block>
            </MediaQueryOwn>
          </Block>
        </CookieBannerWrapper>
      )}
    </>
  )
}



// WEBPACK FOOTER //
// ./src/views/components/CookieBanner/CookieBanner.view.tsx